// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__18LhI","content":"GlobalSearch_content__20juG"};